import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

function LegalPage({ docType, title }) {
  const [content, setContent] = useState("");
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/legal/${docType}`).then((r) => {
      setContent(r.data.content || "");
      setUpdatedAt(r.data.updated_at || null);
      setLoading(false);
    });
  }, [docType]);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-12" data-testid={`legal-page-${docType}`}>
      <div className="mb-6">
        <Link to="/" className="text-sm text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100">← Torna alla home</Link>
      </div>
      {loading ? (
        <div className="text-sm text-zinc-500 dark:text-zinc-400">Caricamento…</div>
      ) : (
        <article className="prose prose-zinc max-w-none prose-headings:font-display prose-headings:font-medium prose-h1:text-4xl prose-h2:text-2xl prose-h3:text-xl prose-a:text-blue-600 prose-table:text-sm">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          {updatedAt && (
            <p className="text-xs text-zinc-400 mt-8 dark:text-zinc-500">
              Documento aggiornato il {new Date(updatedAt).toLocaleDateString("it-IT", { year: "numeric", month: "long", day: "numeric" })}
            </p>
          )}
        </article>
      )}
    </div>
  );
}

export function Privacy() { return <LegalPage docType="privacy" title="Privacy Policy" />; }
export function CookiePolicy() { return <LegalPage docType="cookie" title="Cookie Policy" />; }
export function Dpa() { return <LegalPage docType="dpa" title="DPA — Data Processing Agreement" />; }
export function Terms() { return <LegalPage docType="terms" title="Termini di Servizio" />; }
